import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { navGroups } from '@/config/nav';
import { useApp } from '@/context/AppContext';

export const Sidebar = () => {
  const { t, tx, company } = useApp();

  return (
    <aside
      className="app-chrome hidden lg:flex fixed inset-y-0 left-0 w-[232px] flex-col z-40 sidebar-scroll overflow-y-auto border-r"
      data-testid="app-sidebar"
    >
      <div className="flex items-center px-6 h-16 shrink-0 border-b" style={{ borderColor: 'var(--fp-chrome-border)' }}>
        <span className="font-heading font-extrabold text-lg tracking-tight fp-page-title">FINPULSE</span>
      </div>

      {/* Company */}
      <div className="px-4 py-4">
        <div className="flex items-center gap-3 px-2 py-2 rounded-xl bg-zinc-900/[0.04] border border-zinc-900/10 dark:bg-white/[0.06] dark:border-white/[0.05]">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center text-xs font-bold text-white shrink-0" style={{ background: company?.color }}>
            {company?.logo}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-zinc-900 dark:text-white truncate">{company?.name}</p>
            <p className="text-[11px] text-zinc-500 dark:text-zinc-400 truncate">{tx(company?.sector)}</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 pb-6 space-y-6">
        {navGroups.map((group) => (
          <div key={group.labelKey}>
            <p className="px-3 mb-2 text-[10px] tracking-[0.2em] uppercase font-semibold text-zinc-500">
              {t(group.labelKey)}
            </p>
            <div className="space-y-0.5">
              {group.items.map((item) => (
                <NavLink
                  key={item.key}
                  to={item.path}
                  data-testid={`nav-${item.key}`}
                  className={({ isActive }) =>
                    `group relative flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                      isActive
                        ? 'bg-zinc-900/10 text-zinc-900 font-medium dark:bg-white/10 dark:text-white'
                        : 'text-zinc-500 hover:text-zinc-900 hover:bg-zinc-900/5 dark:text-zinc-400 dark:hover:text-white dark:hover:bg-white/5'
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <motion.span layoutId="nav-indicator" className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-1 rounded-r-full bg-cyan-400" />
                      )}
                      <item.icon className="w-[18px] h-[18px] shrink-0" strokeWidth={2} />
                      <span className="truncate">{t(item.labelKey)}</span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </aside>
  );
};
